import React, { useEffect, useState } from 'react';
import NavSign from './NavSign';
import PersonalRegistration from './PersonalRegistration2';
import './style.scss';
import Features from './Features';
import { toast } from 'react-toastify';
import PhoneOtp from './PhoneOTP';
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';


const SignUp = () => {
    const location = useLocation();
    const mobile = location.state?.form; // Extract 'form' from the state    
    const [step, setStep] = useState(1);
    const [form, setForm] = useState({});
    const authState = useSelector((state) => state.auth);
const isLogin=localStorage.getItem('login')

    useEffect(() => {
        if (mobile) {
            setForm({ ...form, mobile });
            setStep(2); // Move to Phone OTP step
        }
    }, [mobile]);


    const handleNext = (isValid, data) => {
        if (isValid) {
            setForm(data);
            setStep(step + 1);
        } else {
            toast.error("Please fill the form");
        }
    };

    const renderForm = () => {
        switch (step) {
            case 1:
                return <PersonalRegistration onNext={handleNext} form={form} setForm={setForm} />;
            case 2:
                return <PhoneOtp form={form} />;
            default:
                return null;
        }
    };
    return (
        <div>
            <NavSign />
            <div className="container">
                <div className="row" style={{ paddingTop: '40px' }}>
                    <div className="col-lg-7">
                        <div className='signup-section'>
                            <h3 className='signup-text'>Sign Up</h3>
                            {renderForm()}
                        </div>
                    </div>
                    <div className="services-container col-5">
                        <div className='service-form-container'>
                            <h3 className='head-text'>What You Get</h3>
                            <div>
                                <Features />
                            </div>


                            <p className='mt-3' style={{ color: 'white' }}>Already have an account? <Link to={isLogin ? `${process.env.PUBLIC_URL}/dashboard/default` : '/SignIn'} style={{ color: 'white' }}>Login</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SignUp